import React from 'react'
import Menu from 'antd/lib/menu'
import Popover from 'antd/lib/popover'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'
import Checkbox from 'antd/lib/checkbox'
import styled from 'styled-components'
import { IconPlus as Icon, IconMute } from '@edulastic/icons'
import { greenPrimary, themeColor } from '@edulastic/colors'
import './index.scss'
import { LANGUAGES_OPTIONS } from '@edulastic/constants/const/languages'
import { EduButton } from '@edulastic/common'
import { BetaTag } from '../BetaTag'

const BaseLanguageSelectorTab = ({
  handleSelectedLang,
  selectedLanguages,
  handleSaveLanguage,
  isFullWidth,
  isOffset,
  isBeta,
  popoverVisible,
  setPopoverVisible,
  handleChangeLanguage,
  currentLang,
  languageTabsToShow,
  showAddLanguageButton,
  isDisabled,
}) => {
  const menu = (
    <div style={{ width: 300 }}>
      <p>Select at least 1 and maximum 3</p>
      <Row gutter={[20, 20]}>
        {LANGUAGES_OPTIONS.map((language) => (
          <Col span={12}>
            <Checkbox
              onChange={({ target }) =>
                handleSelectedLang(target.checked, language.value)
              }
              checked={selectedLanguages.includes(language.value)}
              disabled={
                (selectedLanguages.length === 3 &&
                  !selectedLanguages.includes(language.value)) ||
                isDisabled
              }
              data-cy={`language-checkbox-${(
                language?.label || ''
              ).toLowerCase()}`}
            >
              {language.label}
              {language.isTTSDisabled && <IconMute />}
            </Checkbox>
          </Col>
        ))}
      </Row>
      <EduButton
        block
        disabled={selectedLanguages.length === 0 || isDisabled}
        style={{ marginLeft: 0 }}
        onClick={handleSaveLanguage}
        data-cy="save-language-button"
      >
        Save
      </EduButton>
    </div>
  )
  return (
    <StyledRow type="flex" isFullWidth={isFullWidth} isOffset={isOffset}>
      {/* Student won't see language selector menu */}
      <Menu
        data-cy="language-selector"
        onClick={handleChangeLanguage}
        selectedKeys={[currentLang]}
        mode="horizontal"
      >
        {LANGUAGES_OPTIONS.filter((lo) =>
          languageTabsToShow.includes(lo.value)
        ).map((language) => (
          <Menu.Item key={language.value}>{language.label}</Menu.Item>
        ))}
      </Menu>
      {showAddLanguageButton && !isDisabled && (
        <Popover
          overlayClassName="language-selector-popover"
          content={menu}
          placement="bottomLeft"
          visible={popoverVisible}
          trigger="click"
          onVisibleChange={(visible) => setPopoverVisible(visible)}
        >
          <StyledButtonRow
            type="flex"
            align="middle"
            data-cy="add-language-button"
          >
            <IconPlus />
            <p>
              Add Language
              {isBeta && <StyledBetaTag>BETA</StyledBetaTag>}
            </p>
          </StyledButtonRow>
        </Popover>
      )}
    </StyledRow>
  )
}

export default BaseLanguageSelectorTab

export const StyledButtonRow = styled(Row)`
  cursor: pointer;
  &:hover {
    p {
      color: ${greenPrimary};
    }
    svg {
      fill: ${greenPrimary};
    }
  }
`

const StyledRow = styled(Row)`
  position: relative;
  top: ${({ isFullWidth }) => (isFullWidth ? '0' : '35px')};
  left: ${({ isFullWidth, isOffset }) =>
    isFullWidth ? (isOffset ? '315px' : '0px') : isOffset ? '315px' : '40px'};
  width: ${({ isFullWidth }) => (isFullWidth ? '100%' : '96%')};
  background: transparent;
  border-bottom: 1px solid #e8e8e8;

  .ant-menu-horizontal {
    border-bottom: 0;
  }

  .ant-menu-item {
    z-index: 1;

    &:hover,
    &.ant-menu-item-selected,
    &.ant-menu-item-active {
      color: ${themeColor};
      border-bottom: 2px solid ${themeColor};
    }
  }

  p {
    color: #999999;
    margin-left: 5px;
    margin-bottom: 0;
    font-weight: 600;
  }
`
export const IconPlus = styled(Icon)`
  width: 10px;
  height: 10px;
  fill: #999999;
`
const StyledBetaTag = styled(BetaTag)`
  position: relative;
  left: 8px;
  top: -8px;
`
